import { api } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const CappedAPIs = {

    GetCappingCheck: async function (bookingId, portalPassengerID, cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/capped/booking/' + bookingId + '/portalpassenger/' + portalPassengerID + '/passengertype/PAYMENT_ACCOUNT',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
}
const cancelAPIObject = defineCancelApiObject(CappedAPIs)